import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import VueGtag from 'vue-gtag'

Vue.config.productionTip = false
Vue.prototype.$axios = axios
axios.defaults.baseURL = 'https://api.ducksu.net/'

Vue.use(VueGtag, {
    config: {
        id: 'GTM-5RVGWF6X'  // Google Analytics의 Tracking ID를 넣어준다
    }
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
